import { render, staticRenderFns } from "./products-manufacture-edit-modal.vue?vue&type=template&id=2ab1a4b1&scoped=true"
import script from "./products-manufacture-edit-modal.vue?vue&type=script&lang=js"
export * from "./products-manufacture-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./products-manufacture-edit-modal.vue?vue&type=style&index=0&id=2ab1a4b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1a4b1",
  null
  
)

export default component.exports